export function normalizeAuthenticatedModules(rows = []) {
  return [...new Set(
    (rows || [])
      .map(row => row?.module_name)
      .filter(moduleName => typeof moduleName === 'string' && moduleName.length > 0)
  )].sort();
}

export function haveSameAuthenticatedModules(current = [], next = []) {
  const currentNormalized = [...(current || [])].sort();
  const nextNormalized = [...(next || [])].sort();

  return currentNormalized.length === nextNormalized.length
    && currentNormalized.every((moduleName, index) => moduleName === nextNormalized[index]);
}

export function mergeAuthenticatedProfile(current, latest, sessionUser) {
  if (!latest) return current;

  const next = {
    ...(current || {}),
    ...latest,
    email: latest.email || sessionUser?.email || current?.email || '',
  };

  if (!current) return next;

  const keys = new Set([...Object.keys(current), ...Object.keys(next)]);
  const unchanged = [...keys].every(key => Object.is(current[key], next[key]));
  return unchanged ? current : next;
}

